// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@stanion/App/SharedStyle/Cart/CartLineSharedStyles";
import { cartLineCardCondensedStyles } from "@stanion/Overrides/Widgets/Cart/CartLineCardCondensed";
import { css } from "styled-components";

cartLineCardCondensedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardCondensedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cartLineCardCondensedStyles.quantity = {
    editableQuantityTextField: {
        ...cartLineSharedStyles.quantityTextField,
    },
};

cartLineCardCondensedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardCondensedStyles.extendedUnitNetPriceText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cartLineCardCondensedStyles.removeCartLineIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

cartLineCardCondensedStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

cartLineCardCondensedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};

cartLineCardCondensedStyles.addLineNotes = {
    css: css`
        @media print {
            display: none !important;
        }
    `,
};

cartLineCardCondensedStyles.cartLineErrorMessageGridItem = {
    ...cartLineSharedStyles.cartLineErrorMessageGridItem,
};

cartLineCardCondensedStyles.qtyLabel = {
    ...cartLineSharedStyles.qtyLabel,
};

cartLineCardCondensedStyles.promo = {
    color: "text.link",
    size: 12,
    weight: "bold",
};
